/**
 * @copyright 2026 @ DigiNet
 * @author YENNHI
 * @create 2026/07/27 10:10
 * @update 2026/07/27 10:10
 */

import { Column } from "devextreme-react/data-grid";
import { Col, Modal, Row, ModalHeader, ModalBody } from 'diginet-core-ui/components';
import React, { useEffect, useState, useRef } from 'react';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as W07F2010Actions from "../../../actions/w07/w07F2010/w07F2010-actions";
import Config from "../../../config";
import GridContainer from "../../common/grid-container/grid-container";

const ModalHistory = (props) => {
    const { open, onClose, dataRow } = props;
    const [dataHistory, setDataHistory] = useState([]);
    const [dataListHistory, setDataListHistory] = useState([]);
    const [historyLoading, setHistoryLoading] = useState(false);
    const [historyListLoading, setHistoryListLoading] = useState(false);
    const gridRef = useRef(null);

    useEffect(() => {
        loadHistory();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (dataHistory.length > 0) {
            const firstRow = dataHistory[0];
            loadListHistory(firstRow.AuditID);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dataHistory]);

    const getParam = (DataTypeID, data) => {
        const params = {
            DataTypeID,
            DateFrom: null,
            DateTo: null,
            PeriodFrom: null,
            PeriodTo: null,
            RDVoucherID: "",
            StrSearch: ""
        };
        return params;
    }

    const loadHistory = () => {
        const params = {
            ...getParam("History"),
            RDVoucherID: dataRow?.RDVoucherID || ""
        };
        setHistoryLoading(true);
        props.W07F2010Actions.loadHistory(params, (error, data) => {
            setHistoryLoading(false);
            if (error) {
                Config.popup.show("ERROR", error);
                return false;
            } else if (data) {
                setDataHistory(data);
                if (!Config.isEmpty(data) && gridRef.current) gridRef.current.instance.option("focusedRowIndex", 0);
            }
        })
    }

    const loadListHistory = (auditID = "") => {
        const params = {
            ...getParam("ListHistory"),
            JsonData: auditID || ""
        };
        setHistoryListLoading(true);
        props.W07F2010Actions.loadHistory(params, (error, data) => {
            setHistoryListLoading(false);
            if (error) {
                Config.popup.show("ERROR", error);
                return false;
            } else if (data) {
                setDataListHistory(data)
            }
        })
    }

    const onRowClick = (e) => {
        loadListHistory(e.data.AuditID);
    };

    return (
        <>
            <Modal
                open={open}
                size={'lg'}
                onClose={onClose} >
                <ModalHeader>{Config.lang("Lich_su_chinh_sua")}</ModalHeader>
                <ModalBody>
                    <Row>
                        <Col xs={12} sm={4}>
                            <GridContainer
                                reference={ref => gridRef.current = ref}
                                dataSource={dataHistory}
                                loading={historyLoading}
                                typePaging={'normal'}
                                keyExpr={'AuditID'}
                                itemPerPage={20}
                                listPerPage={[20, 40, 60, 80]}
                                elementAttr={{ style: 'min-height: 300px' }}
                                filterRow={{
                                    visible: true,
                                    showOperationChooser: false,
                                }}
                                onRowClick={onRowClick}
                                selection={{ mode: "none" }}
                                focusedRowEnabled={true}
                            >
                                <Column
                                    allowEditing={false}
                                    caption={Config.lang("STT")}
                                    alignment={"center"}
                                    cellRender={e => e.rowIndex + 1}
                                    width={100}
                                />
                                <Column
                                    caption={Config.lang("Nguoi_sua")}
                                    visible={false}
                                    dataField={"AuditID"}
                                    allowEditing={false}
                                />
                                <Column
                                    caption={Config.lang("Ngay_sua")}
                                    dataField={"AuditDate"}
                                    alignment={"center"}
                                    dataType={"date"}
                                    format={"dd/MM/yyyy"}
                                    allowEditing={false}
                                />
                                <Column
                                    caption={Config.lang("Nguoi_sua")}
                                    visible={false}
                                    dataField={"UserID"}
                                />
                                <Column
                                    caption={Config.lang("Nguoi_sua")}
                                    dataField={"UserName"}
                                    alignment={"center"}
                                    allowEditing={false}
                                />
                            </GridContainer>

                        </Col>
                        <Col xs={12} sm={8}>
                            <GridContainer
                                dataSource={dataListHistory}
                                loading={historyListLoading}
                                typePaging={'normal'}
                                keyExpr={'AuditDetailID'}
                                itemPerPage={20}
                                listPerPage={[20, 40, 60, 80]}
                                elementAttr={{ style: 'min-height: 300px' }}
                                filterRow={{
                                    visible: true,
                                    showOperationChooser: false,
                                }}
                            >
                                <Column
                                    allowEditing={false}
                                    caption={Config.lang("STT")}
                                    alignment={"center"}
                                    cellRender={e => e.rowIndex + 1}
                                    width={100}
                                />
                                <Column
                                    caption={Config.lang("Noi_dung")}
                                    dataField={"Caption"}
                                    alignment={"left"}
                                    allowEditing={false}
                                />
                                <Column
                                    caption={Config.lang("Gia_tri_cu")}
                                    dataField={"OldValue"}
                                    alignment={"left"}
                                    allowEditing={false}
                                />
                                <Column
                                    caption={Config.lang("Gia_tri_moi")}
                                    dataField={"NewValue"}
                                    alignment={"left"}
                                    allowEditing={false}
                                />
                            </GridContainer>
                        </Col>
                    </Row>
                </ModalBody>
            </Modal>
        </>
    )
}

export default connect(null, (dispatch) => ({
    W07F2010Actions: bindActionCreators(W07F2010Actions, dispatch),
}))(ModalHistory);